import _ from 'lodash';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { DESELECT_COMPONENT, SET_ONGOING_EDIT_GLOBALLY, SET_SELECTED_COMPONENT_ID, UPDATE_EQUIPMENT_UNIT_NAME } from '../../../store/actions';
import { DEFAULT_EQUIPMENT_UNIT_NAME, RESPONSE_EQUIPMENT_UNIT_RENAME_FAILED_CODE } from '../../../Common/constants';
import EquipmentUnitFoundation from './EquipmentUnitFoundation';
import EquipmentUnitClass from './EquipmentUnitClass';
import ApplyCategoryToEquipmentUnit from '../Admin/EquipmentUnitCategory/ApplyCategoryToEquipmentUnit';
import RemoveCategory from './RemoveCategory';
import { useMutation } from 'react-query';
import { renameEntity } from '../../../api';
import { ClipLoader } from 'react-spinners';
import { checkForAPISuccess, showErrorToast, showInfoToast, showSuccessToast } from '../../../Common/commonFunctions';
import ToolTip from '../Common/Tooltip';
import EquipmentUnitPositiveDisplacementField from './EquipmentUnitPositiveDisplacementField';

const EquipmentUnitList = props => {

    const dispatch = useDispatch();
    const allEquipmentUnits = useSelector(state => state.equipment.currentEquipmentUnits);
    const selectedComponent = useSelector(state => state.equipment.selectedComponent);
    const isEditOngoing = useSelector(state => state.equipment.isEditOngoing);
    const isLockedProfile = useSelector(state => state.equipment.isLockedProfile);
    const currentEnlargedImageType = useSelector(state => state.equipment.currentEnlargedImageType);
    const isComponentLoading = useSelector(state => state.equipment.componentLoading);

    const [utils, setUtils] = useState({
        equipmentUnits: {},
        equipmentUnitInCategoryApply: "",
        equipmentUnitInCategoryRemove: "",
        equipmentUnitInEdit: { id: "", name: "", initialName: "" }
    });

    const reOrderEquipmentUnits = (equipmentUnits) => {
        if(!_.isEmpty(equipmentUnits) && !_.isEmpty(equipmentUnits[DEFAULT_EQUIPMENT_UNIT_NAME])) {
            let updatedEquipmentUnits = _.cloneDeep(equipmentUnits), defaultUnit = _.cloneDeep(equipmentUnits[DEFAULT_EQUIPMENT_UNIT_NAME]);
            updatedEquipmentUnits[DEFAULT_EQUIPMENT_UNIT_NAME] = "";
            updatedEquipmentUnits[DEFAULT_EQUIPMENT_UNIT_NAME] = defaultUnit;
            return updatedEquipmentUnits;
        }
        else {
            return equipmentUnits;
        }
    }

    const checkIfDefaultEquipmentUnitOrNot = (name) => name.toUpperCase() !== DEFAULT_EQUIPMENT_UNIT_NAME

    useEffect(() => {
        setUtils({
            ...utils,
            equipmentUnits: !_.isEmpty(allEquipmentUnits) ? reOrderEquipmentUnits(allEquipmentUnits) : {},
            equipmentUnitInCategoryApply: "", equipmentUnitInCategoryRemove: "", equipmentUnitInEdit: {}
        });
    }, [allEquipmentUnits]);

    const checkIfComponentSelected = (id) =>  !_.isEmpty(selectedComponent) && _.isEqual(id, selectedComponent.id);

    const setCurrentComponent = (id) => {
        if(checkIfComponentSelected(id)) {
            dispatch({ type: DESELECT_COMPONENT });
        }
        else {
            dispatch({ type: SET_SELECTED_COMPONENT_ID, payload: id });
        }
    }

    const setCurrentEquipmentUnitInEdit = (name, id, action) => {
        setUtils({
            ...utils,
            equipmentUnitInEdit: action === "SET" ?
                {
                    id: id,
                    name: checkIfDefaultEquipmentUnitOrNot(name) ? name : "",
                    initialName: checkIfDefaultEquipmentUnitOrNot(name) ? name : ""
                }
                    :
                {}
        });
        dispatch({ type: SET_ONGOING_EDIT_GLOBALLY, payload: action === "SET" });
    }

    const updateEquipmentUnitName = async () => {
        if(utils.equipmentUnitInEdit.name.toUpperCase() === DEFAULT_EQUIPMENT_UNIT_NAME) {
            showInfoToast("Provided name is a reserved keyword. Please provide a different name", 6000);
        }
        else {
            const response = await renameEntity(
                "equipment-unit",
                {
                    id: utils.equipmentUnitInEdit.id,
                    name: utils.equipmentUnitInEdit.name
                }
            );
            if(checkForAPISuccess(response?.data?.statusCode)) {
                showSuccessToast("Updated name successfully");
                dispatch({ type: UPDATE_EQUIPMENT_UNIT_NAME, payload: utils.equipmentUnitInEdit });
            }
            else if(response?.data?.statusCode === RESPONSE_EQUIPMENT_UNIT_RENAME_FAILED_CODE) {
                showInfoToast("Provided name is taken. Please provide different name", 5000);
            }
            else {
                showErrorToast("Failed to update equipment unit name");
                setUtils({ ...utils, equipmentUnitInEdit: {} });
                dispatch({ type: SET_ONGOING_EDIT_GLOBALLY, payload: false });
            }
        }
    }

    const updateEquipmentUnitNameMutation = useMutation(updateEquipmentUnitName);

    return (
        <PerfectScrollbar style={{"height": "280px"}}>
            {
                !_.isEmpty(utils.equipmentUnits) ?
                    (
                        <>
                            {
                                Object.keys(utils.equipmentUnits).map((currentEquipmentUnitName, key1) => {
                                    const currentEquipmentUnit = utils.equipmentUnits[currentEquipmentUnitName];
                                    const isCategoryApplied = !_.isEmpty(currentEquipmentUnit?.appliedCategoryName);
                                    return (
                                        <div key={key1}>
                                            <div className={"equipment-unit-header"}>
                                                {
                                                    <div className='m-1'>
                                                        {
                                                            utils.equipmentUnitInEdit.id === currentEquipmentUnit.id ?
                                                                updateEquipmentUnitNameMutation.isLoading ?
                                                                    <ClipLoader size={20} color='#075978' />
                                                                        :
                                                                    <div className='mb-1'>
                                                                        <input
                                                                            onChange={(e) =>
                                                                                setUtils({
                                                                                    ...utils,
                                                                                    equipmentUnitInEdit: {
                                                                                        ...utils.equipmentUnitInEdit,
                                                                                        name: e.target.value
                                                                                    }
                                                                                })
                                                                            }
                                                                            value={utils.equipmentUnitInEdit.name}
                                                                            className='equipment-unit-name-edit'
                                                                        />
                                                                        {
                                                                            (
                                                                                !_.isEmpty(utils.equipmentUnitInEdit.name) &&
                                                                                utils.equipmentUnitInEdit.id === currentEquipmentUnit.id &&
                                                                                utils.equipmentUnitInEdit.name !== utils.equipmentUnitInEdit.initialName
                                                                            ) &&
                                                                            <Icon
                                                                                onClick={() => updateEquipmentUnitNameMutation.mutate()}
                                                                                className='cursor-pointer ml-2'
                                                                                icon={"feather-check"}
                                                                                width={18}
                                                                                height={18}
                                                                            />
                                                                        }
                                                                        <Icon
                                                                            className='cursor-pointer ml-2'
                                                                            icon={"feather-x"}
                                                                            width={18}
                                                                            height={18}
                                                                            onClick={() => setCurrentEquipmentUnitInEdit(null, null, "CANCEL")}
                                                                        />
                                                                    </div>
                                                                    :
                                                                <div className='d-flex'>
                                                                    <div>
                                                                        {
                                                                            checkIfDefaultEquipmentUnitOrNot(currentEquipmentUnitName) ?
                                                                                currentEquipmentUnitName
                                                                                    :
                                                                                "-"
                                                                        }
                                                                    </div>
                                                                    {
                                                                        (!isEditOngoing && !isLockedProfile) &&
                                                                            <Icon
                                                                                onClick={() =>
                                                                                    setCurrentEquipmentUnitInEdit(
                                                                                        currentEquipmentUnitName,
                                                                                        currentEquipmentUnit.id,
                                                                                        "SET"
                                                                                    )
                                                                                }
                                                                                className='ml-2 mt-1 cursor-pointer'
                                                                                icon={"feather-edit-2"}
                                                                            />
                                                                    }
                                                                </div>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                            {
                                                !_.isEmpty(utils.equipmentUnitInCategoryApply) && utils.equipmentUnitInCategoryApply === currentEquipmentUnit.id && 
                                                    <ApplyCategoryToEquipmentUnit
                                                        close={() => setUtils({ ...utils, equipmentUnitInCategoryApply: "" })}
                                                        id={currentEquipmentUnit.id}
                                                        name={currentEquipmentUnitName}
                                                        equipmentId={props.equipmentId}
                                                    />
                                            }
                                            {
                                                !_.isEmpty(utils.equipmentUnitInCategoryRemove) && utils.equipmentUnitInCategoryRemove === currentEquipmentUnit.id &&
                                                    <RemoveCategory
                                                        close={() => setUtils({ ...utils, equipmentUnitInCategoryRemove: "" })}
                                                        id={currentEquipmentUnit.id}
                                                        name={currentEquipmentUnitName}
                                                        equipmentId={props.equipmentId}
                                                    />
                                            }
                                            {
                                                <>
                                                    <EquipmentUnitFoundation
                                                        id={currentEquipmentUnit.id}
                                                        foundation={currentEquipmentUnit.foundation}
                                                        name={currentEquipmentUnitName}
                                                    />
                                                    {
                                                        !_.isEmpty(currentEquipmentUnit?.components) &&
                                                            <EquipmentUnitClass
                                                                id={currentEquipmentUnit.id}
                                                                name={currentEquipmentUnitName}
                                                                class={currentEquipmentUnit.class}
                                                            />
                                                    }
                                                </>
                                            }
                                            {
                                                <EquipmentUnitPositiveDisplacementField
                                                    id={currentEquipmentUnit.id}
                                                    name={currentEquipmentUnitName}
                                                    positiveDisplacement={currentEquipmentUnit?.isPositiveDisplacement}
                                                />
                                            }
                                            {
                                                <div className='pt-1 equipment-unit-list-field'>
                                                    <div className='ml-2 w-50'>
                                                        Applied category
                                                    </div>
                                                    <div className='mr-1 w-50 justify-end'>
                                                        <div className={`applied-category ${isLockedProfile ? "mr-2" : ""}`}>
                                                            { isCategoryApplied ? currentEquipmentUnit?.appliedCategoryName : <b>-</b> }
                                                        </div>
                                                        {
                                                            !isLockedProfile && 
                                                                <ToolTip
                                                                    toolTipKey={"category-tooltip"}
                                                                    toolTipValue={(isCategoryApplied ? "Remove" : "Apply") + " category"}
                                                                    overlayComponent={
                                                                        <Icon
                                                                            color={isEditOngoing ? "grey" : "#075978"}
                                                                            className={`ml-2 mr-1 ${isEditOngoing ? "disable-click" : "cursor-pointer"}`}
                                                                            width={20} height={20}
                                                                            icon={isCategoryApplied ? "feather-minus-circle" : "feather-plus-circle"}
                                                                            onClick={() =>
                                                                                {
                                                                                    if(isCategoryApplied) {
                                                                                        setUtils({ ...utils, equipmentUnitInCategoryRemove: currentEquipmentUnit.id });
                                                                                    }
                                                                                    else {
                                                                                        setUtils({ ...utils, equipmentUnitInCategoryApply: currentEquipmentUnit.id });
                                                                                    }
                                                                                }
                                                                            }
                                                                        />
                                                                    }
                                                                />
                                                        }
                                                    </div>
                                                </div>
                                            }
                                            {
                                                !_.isEmpty(currentEquipmentUnit?.components) ?
                                                <>
                                                    {
                                                        currentEquipmentUnit.components.map((component, key2) => 
                                                            <div key={key2}
                                                                onClick={() => setCurrentComponent(component.id)}
                                                                className={
                                                                    (checkIfComponentSelected(component.id) ? "equipment-unit-selected" : "equipment-unit") + 
                                                                    (isEditOngoing || !_.isEmpty(currentEnlargedImageType) || isComponentLoading ? " disable-click" : "")
                                                                }
                                                            >
                                                                <div style={{ marginLeft: "10px" }} className='pl-2'>{component.name}</div>
                                                                <div style={{"fontSize": "12px"}} className='pr-2 pt-1 text-color-grey'>{component.type}</div>
                                                            </div>
                                                        )
                                                    }
                                                </>
                                                    :
                                                <center className='p-2 font-weight-bold'>
                                                    NO COMPONENTS FOUND
                                                </center>
                                            }
                                        </div>
                                    );
                                })
                            }
                        </>
                    )
                        :
                    <div className='h-100 d-flex align-items-center justify-content-center font-weight-bold'>NO EQUIPMENT UNITS FOUND</div>
            }
        </PerfectScrollbar>
    );
};

export default EquipmentUnitList;
